import React from 'react';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CollapseIcon } from '@/assets/images/icons/collapse.svg';
import { ReactComponent as ExpandIcon } from '@/assets/images/icons/expand.svg';
import useMobileView from '@/hooks/ui/useMobileView';
import translate from '@/lib/intl/translate';
import { LayoutContext } from './LayoutProvider';

function ToggleSidebar() {
  const { isExpanded, setShowHover, setIsExpanded } =
    React.useContext(LayoutContext);
  const isMobile = useMobileView();

  if (isMobile) {
    return null;
  }

  return (
    <IconButton
      aria-label={translate('TOGGLE_SIDEBAR')}
      aria-pressed={isExpanded}
      className="absolute right-[-12px] top-[52px] z-[1000] h-6 w-6 bg-white text-primary-main shadow hover:shadow-[0_0_5px_0_rgba(80,57,173,0.85)] focus-visible:[outline:auto]"
      id="nav-expand-toggle-button"
      onClick={() => {
        setIsExpanded(!isExpanded);
        setShowHover(false);
      }}
    >
      <SvgIcon
        aria-label={
          isExpanded ? translate('ICON_EXPAND') : translate('ICON_COLLAPSE')
        }
        className="[&_*]:text-primary-light"
        component={isExpanded ? CollapseIcon : ExpandIcon}
        viewBox={isExpanded ? '0 -6 10 24' : '0 -6 6 24'}
        width="24"
        height="24"
      />
    </IconButton>
  );
}

export default ToggleSidebar;
